import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import classNames from 'classnames'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import consts from '../../../util/consts'
import Paginate from '../../components/Pagination'
import { fetchTechnicalAbsencesRelatoryInit } from '../TechnicalAbsencesRelatoryActions'
import {
  StyledTableCellBody,
  StyledTableCellHeader,
} from '../../../components/hooks/BaseTableComponents'
import { maskedDateFormatter } from '@material-ui/pickers/_helpers/text-field-helper'
import { dateFormatedFullDate } from '../../../util/utils'

function List(props) {
  const dispatch = useDispatch()
  const filters = useSelector(
    state => state.technical_absences_relatory.filters
  )
  const [rowsPerPage, setRowsPerPage] = useState(consts.DEFAULT_PAGINATION)
  const { classes, items, totalSize, page } = props

  const onMovePage = (event, newPage) => {
    dispatch(
      fetchTechnicalAbsencesRelatoryInit(
        newPage + 1,
        { ...filters, withTrashed: true },
        rowsPerPage
      )
    )
  }

  useEffect(() => {
    onMovePage()
  }, [rowsPerPage])

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(event.target.value)
  }

  return (
    <>
      <TableContainer
        className={classNames({
          [classes.tableContainer]: true,
          [classes.tableStickHeader]: true,
        })}
      >
        <Table stickyHeader size="medium" className={classes.tableStyle}>
          <TableHead>
            <TableRow>
              <StyledTableCellHeader>Tecnico</StyledTableCellHeader>
              <StyledTableCellHeader>Data Inicial</StyledTableCellHeader>
              <StyledTableCellHeader>Data Final</StyledTableCellHeader>
              <StyledTableCellHeader>Criado Por</StyledTableCellHeader>
              <StyledTableCellHeader>Data de Criação</StyledTableCellHeader>
              <StyledTableCellHeader>Motivo</StyledTableCellHeader>

              <StyledTableCellHeader>Deletado Por</StyledTableCellHeader>

              <StyledTableCellHeader>Data de Exclusão</StyledTableCellHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map(item => (
              <TableRow key={item.id}>
                <StyledTableCellBody>
                  {item.technical?.name}
                </StyledTableCellBody>
                <StyledTableCellBody>
                  {dateFormatedFullDate(item.date_start)}
                </StyledTableCellBody>
                <StyledTableCellBody>
                  {dateFormatedFullDate(item.date_end)}
                </StyledTableCellBody>
                <StyledTableCellBody>
                  {item.created_user?.name || '-'}
                </StyledTableCellBody>
                <StyledTableCellBody>
                  {dateFormatedFullDate(item.created_at)}
                </StyledTableCellBody>
                <StyledTableCellBody>{item.reason}</StyledTableCellBody>
                <StyledTableCellBody>
                  {item.deleted_user?.name || '-'}
                </StyledTableCellBody>
                <StyledTableCellBody>
                  {dateFormatedFullDate(item.deleted_at) || '-'}
                </StyledTableCellBody>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Paginate
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        rowsPerPage={rowsPerPage}
        rows={totalSize}
        page={page - 1}
        handleChangePage={onMovePage}
      />
    </>
  )
}

export default List
